import React from "react";
import "./page-header.scss";
import BrandLogo from "../../../images/home/down-arrow-light-green.svg";
import DownArrowLightGreen from "../../../images/home/down-arrow-light-green.svg";
import PinIcon from "../../../images/home/pin-icon.svg";
import { getDistance, getDistanceNew } from "../../../components/common/utils";
import ProfileStoreGreen from "../../../images/home/profile-store-green.svg";
import Loader from "../../../components/common/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
const PageHeader = ({ sellerDetails, isOpen = false, setStoreTiming }) => {
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const sellerLocation = sellerDetails?.locations?.[0]?.gps?.split(",");
  const sellerLat = parseFloat(sellerLocation?.[0]);
  const sellerLon = parseFloat(sellerLocation?.[1]);
  const [distance, setDistance] = useState("")
  const defaultLat = parseFloat(defaultAddress?.latitude);
  const defaultLon = parseFloat(defaultAddress?.longitude);
      console.log(sellerDetails,'sellerDetails')

  useEffect(() => {
    async function calculateDistances() {
      const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
      const sellerLocation = sellerDetails?.locations?.[0]?.gps?.split(",");
      const sellerLat = parseFloat(sellerLocation?.[0]);
      const sellerLon = parseFloat(sellerLocation?.[1]);
      const defaultLat = parseFloat(defaultAddress?.latitude);
      const defaultLon = parseFloat(defaultAddress?.longitude);

      const dist = await getDistanceNew(
        defaultLat,
        defaultLon,
        sellerLat,
        sellerLon
      );
      console.log(dist,'dist')
      setDistance(dist);
    }

    calculateDistances();
  }, [sellerDetails]);

  // const distance = getDistance(defaultLat, defaultLon, sellerLat, sellerLon);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <div className="page-header-bg-container-kl">
        <div className="page-header-bg-container-inner-kl">
          {sellerDetails && sellerDetails?.photo ? (
            <>
              <div className="page-header-logo-kl">
                <img
                  src={sellerDetails?.photo}
                  alt="Seller Profile"
                  onError={(event) => {
                    event.target.onerror = null;
                    event.target.src = BrandLogo;
                    event.target.classList.add("default-img");
                  }}
                />
              </div>
              <div className="page-header-location-kl">
                <div className="page-header-location-title-kl">
                  {sellerDetails?.name ?? ""}
                </div>
                <div className="page-header-location-sub-title-kl">
                  <span>
                    {sellerDetails?.locations?.[0]?.address?.city ?? ""}
                  </span>
                  <span> </span>
                  <span>
                    {sellerDetails?.locations?.[0]?.address?.state ?? ""}
                  </span>
                  <span> </span>
                  <span>
                    {sellerDetails?.locations?.[0]?.address?.area_code ?? ""}
                  </span>
                </div>

                <div className="page-header-location-sub-title-kl">
                  <div className="page-header-location-list-kl">
                    <div className="page-header-location-items-kl">
                      <img className="pin-icon-kl" src={PinIcon} alt="" />
                      {distance> 0 ? distance?.toFixed(2) : "0.00"} Km
                    </div>
                    <div
                      className="page-header-location-items-kl"
                      onClick={() => setStoreTiming(true)}
                    >
                      <img
                        className="delete-icon-kl"
                        src={ProfileStoreGreen}
                        alt=""
                      />
                      {isOpen ? "OPEN" : "CLOSED"}
                      <img src={DownArrowLightGreen} alt="" />
                    </div>
                  </div>
                </div>
                {(location.pathname === "/qc" ||
                  location.pathname === "/quickcommerce") && (
                  <button
                    onClick={() => {
                      navigate("/", { state: { scrollTo: "nearBySection" } });
                    }}
                    className="view-all-stores-btn-mobile"
                  >
                    View All Stores
                  </button>
                )}
              </div>
            </>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </>
  );
};
export default PageHeader;
